import { HttpClient } from "@angular/common/http";
import { Injectable, PLATFORM_ID, inject } from "@angular/core";

import { Observable } from "rxjs";

import { environment } from "../../../../public/environments/environment";
import { IApiResponse } from "../interface/api-response.interface";
import { Params } from "../interface/core.interface";
import { OrderMaster } from "../interface/order-master.interface";
import { IOrderModel } from "../interface/order.interface";
import { BaseUrlEnum, getBaseURL } from "./common/base-url-resolver.util";
import { MasterService } from "./common/master.service";

@Injectable({
  providedIn: "root",
})
export class OrderService {
  private http = inject(HttpClient);
  private masterService = inject(MasterService);
  private platformId = inject<Object>(PLATFORM_ID);
  public skeletonLoader: boolean = false;

  getOrders(payload?: Params): Observable<IOrderModel> {
    return this.http.get<IOrderModel>(`${environment.URL}/order.json`, {
      params: payload,
    });
  }
  createOrder(order: OrderMaster): Observable<IApiResponse> {
    return this.masterService.post<IApiResponse>(
      getBaseURL(this.platformId, BaseUrlEnum.Ordering),
      `Ordering`,
      order
    );
  }
  SaaScreateOrderNew(order: OrderMaster): Observable<IApiResponse> {
    return this.masterService.post<IApiResponse>(
      getBaseURL(this.platformId, BaseUrlEnum.Ordering),
      `Ordering/SaaSOrderCreate`,
      order
    );
  }
  UpdateOrderAddress(id: number, order: OrderMaster): Observable<IApiResponse> {
    return this.masterService.put<IApiResponse>(
      getBaseURL(this.platformId, BaseUrlEnum.Ordering),
      `Ordering/UpdateOrderAddress/${id}`,
      order
    );
  }
  getOrderDetails(orderCode: string): Observable<IApiResponse> {
    return this.masterService.get<IApiResponse>(
      getBaseURL(this.platformId, BaseUrlEnum.Ordering),
      `Ordering/GetOrderByCode?code=${orderCode}`
    );
  }

  OrdersByCustomer(cusId: number): Observable<IApiResponse> {
    return this.masterService.get<IApiResponse>(
      getBaseURL(this.platformId, BaseUrlEnum.Ordering),
      `Ordering/OrdersByCustomer/${cusId}`
    );
  }

  cancelOrder(orderCode: string): Observable<IApiResponse> {
    const body = {
      code: orderCode,
      status: 4,
      userId: 0,
    };

    return this.masterService.put<IApiResponse>(
      getBaseURL(this.platformId, BaseUrlEnum.Ordering),
      `Ordering/update-status/${orderCode}`,
      body
    );
  }

  updateorderreturnstatus(orderCode: string): Observable<IApiResponse> {
    const body = {
      code: orderCode,
      status: 7,
      userId: 0,
    };

    return this.masterService.put<IApiResponse>(
      getBaseURL(this.platformId, BaseUrlEnum.Ordering),
      `Ordering/update-order-return-status/${orderCode}`,
      body
    );
  }

  CheckCustomerHasHistoryOrNot(number: string): Observable<IApiResponse> {
    return this.masterService.get<IApiResponse>(
      getBaseURL(this.platformId, BaseUrlEnum.Ordering),
      `Order/Customer/CheckCustomerHasHistoryOrNot/${number}`
    );
  }

  TransferGuestOrdersToCustomerByNumber(
    number: string
  ): Observable<IApiResponse> {
    return this.masterService.put<IApiResponse>(
      getBaseURL(this.platformId, BaseUrlEnum.Ordering),
      `Ordering/TransferGuestOrdersToCustomerByNumber/${number}`,
      null
    );
  }

  OrderReturn(orderreturn: any[]): Observable<IApiResponse> {
    return this.masterService.post<IApiResponse>(
      getBaseURL(this.platformId, BaseUrlEnum.Ordering),
      `Ordering/order-return`,
      orderreturn
    );
  }

  GetDeliveryArea(): Observable<IApiResponse> {
    return this.masterService.get<IApiResponse>(
      getBaseURL(this.platformId, BaseUrlEnum.Ordering),
      `Ordering/DeliveryArea`
    );
  }

  GetDeliverySectionOrBlock(): Observable<IApiResponse> {
    return this.masterService.get<IApiResponse>(
      getBaseURL(this.platformId, BaseUrlEnum.Ordering),
      `Ordering/DeliverySectionOrBlock`
    );
  }

  updateOrderAddress(id: number, order: OrderMaster): Observable<IApiResponse> {
    return this.masterService.put<IApiResponse>(
      getBaseURL(this.platformId, BaseUrlEnum.Ordering),
      `Ordering/UpdateOrderAddress/${id}`,
      order
    );
  }

  GetAllDeliveryStatus(): Observable<IApiResponse> {
    return this.masterService.get<IApiResponse>(
      getBaseURL(this.platformId, BaseUrlEnum.Delivery),
      `Delivery/Shipment/delivery-status`
    );
  }

  getOrderDeliveryDetails(invoiceNo: string): Observable<IApiResponse> {
    return this.masterService.get<IApiResponse>(
      getBaseURL(this.platformId, BaseUrlEnum.Delivery),
      `Delivery/Shipment/Delivery-Steps/${invoiceNo}`
    );
  }

  getOrderLastStatusBeforeRetrun(invoiceNo: string): Observable<IApiResponse> {
    return this.masterService.get<IApiResponse>(
      getBaseURL(this.platformId, BaseUrlEnum.Ordering),
      `Order/Ordering/last-status-before-return-by-InvoiceNo/${invoiceNo}`
    );
  }
}
